module.exports = __webpack_public_path__ + "img/百香果13.e30a98c8.png";